import { cmApi } from '@/api/cmApi'
import { authHeaders } from '@/auth/session'

/**
 * Lab `Game/getGames` row. `_id` is the Lab Mongo Game id that
 * `Account/getDownlineAccountsData` `game` still expects.
 */
export type GetGamesRow = {
  _id: string
  name: string
  rules?: string
}

export type GetGamesResponse = {
  value: boolean
  data: GetGamesRow[]
}

/** Lab PL Statement hid these table-game names from the product dropdown. */
const HIDDEN_GAME_NAMES = new Set(['TeenPatti', 'Poker', 'Roulette'])

/** Normalize the Lab callback and drop the names PL Statement never listed. */
export function rowsFromGetGames(response: GetGamesResponse): GetGamesRow[] {
  if (!response.value) return []
  return (response.data ?? []).filter(
    (row) => Boolean(row._id && row.name) && !HIDDEN_GAME_NAMES.has(row.name),
  )
}

/** Product picker — CM-API `POST /v1/game/getGames`. */
export async function getGames(): Promise<GetGamesRow[]> {
  const response = await cmApi.getGames(authHeaders())
  return rowsFromGetGames(response)
}

export type GetSubGamesResponse = {
  value: boolean
  data: string[]
}

/** Lab callback `{ value, data: string[] }` — names for the Sub Game picker. */
export function namesFromGetSubGames(response: GetSubGamesResponse): string[] {
  if (!response.value) return []
  return (response.data ?? []).filter(
    (name): name is string => typeof name === 'string' && Boolean(name.trim()),
  )
}

/** Sport / table picker — CM-API `POST /v1/account/getSubGames`. */
export async function getSubGames(game?: string | null): Promise<string[]> {
  const body = game && game !== 'all' ? { game } : { game: 'all' }
  const response = await cmApi.getSubGames(authHeaders(), body)
  return namesFromGetSubGames(response)
}
